const config = {
    "api": {
        "baseURL": "https://apitest.prometheuspro.us/api",
        // "baseURL": "https://api.prometheuspro.dev/api",
    },
    "exports": {
        "baseURL": "https://apitest.prometheuspro.us/tmp/",
        // "baseURL": "https://api.prometheuspro.dev/tmp/",
    },
    "customize": {
        "baseURL": "https://apitest.prometheuspro.us/api/pm",
        // "baseURL": "https://api.prometheuspro.dev/api/pm",
    },
    "privatelabel": {
        "baseURL": "https://privatelabel.prometheuspro.dev",
        // "baseURL": "https://api.prometheuspro.dev",
    },
}

export default config